var nanobus = require('nanobus');
var ActiveFilters = /** @class */ (function () {
    function ActiveFilters() {
        this.events = nanobus();
        this.evaluators = [
            checkAcpSmartFilters,
            checkAcpFilters,
            checkWpSearchBox
        ];
    }
    ActiveFilters.prototype.hasActiveFilters = function () {
        var hasActiveFilters = false;
        this.evaluators.forEach(function (evaluator) {
            if (evaluator()) {
                hasActiveFilters = true;
            }
        });
        return hasActiveFilters;
    };
    ActiveFilters.prototype.addEvaluator = function (evaluator) {
        this.evaluators.push(evaluator);
    };
    ActiveFilters.prototype.onRefresh = function (callback) {
        this.events.on('refresh', function () {
            callback();
        });
    };
    ActiveFilters.prototype.refresh = function () {
        this.events.emit('refresh');
    };
    return ActiveFilters;
}());
export { ActiveFilters };
var checkWpSearchBox = function () {
    var hasActiveFilters = false;
    document.querySelectorAll('.search-box input[name=s]').forEach(function (e) {
        if (e.value !== '') {
            hasActiveFilters = true;
        }
    });
    return hasActiveFilters;
};
var checkAcpSmartFilters = function () {
    var hasActiveFilters = false;
    if (AdminColumns.Search && AdminColumns.Search.getRules().rules.length > 0) {
        hasActiveFilters = true;
    }
    return hasActiveFilters;
};
var checkAcpFilters = function () {
    var hasActiveFilters = false;
    if (document.querySelectorAll('.acp-filter.active, .acp-range.active').length > 0) {
        hasActiveFilters = true;
    }
    document.querySelectorAll('.acp-filter').forEach(function (el) {
        if (el.value !== '') {
            hasActiveFilters = true;
        }
    });
    return hasActiveFilters;
};
